export const STYLES = {
  CONTAINER: 'min-h-screen bg-gray-50',
  INNER_CONTAINER: 'container mx-auto max-w-4xl relative space-y-8 px-0 py-6 md:p-6',
  BACK_BUTTON: 'absolute -left-47 top-0 text-gray-600 hover:text-gray-900 hover:bg-gray-100 z-10',
  HERO_IMAGE: 'w-full h-64 md:h-80 bg-gray-200',
  IMAGE: 'w-full h-full object-cover',
  CONTENT_WRAPPER: 'space-y-6 pt-6 px-4 md:px-0',
  TITLE: 'text-3xl md:text-4xl font-bold text-gray-900',
  BRIEF_DESC:
    'text-base text-gray-700 leading-relaxed border-l-4 border-teal-600 pl-4 bg-gray-50 p-4 rounded-r',
  PROSE: 'prose max-w-none space-y-4',
  FOOTER: 'border-t border-gray-200 flex justify-center items-center h-24',
  LOGO: 'h-12',
  PARAGRAPH: 'text-gray-700 leading-relaxed',
  PARAGRAPH_CONTAINER: 'space-y-2',
  HEADING: 'text-2xl font-bold text-gray-900',
  SUBHEADING_CONTAINER: 'space-y-2',
  SUBHEADING_TITLE: 'text-base font-semibold text-gray-900',
  BULLETS_LIST: 'list-disc ml-6 space-y-2 text-gray-700',
  BULLET_ITEM: 'leading-relaxed',
};
